import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import ModalComponent from '../ui/Modal';

import { popError } from '../global/actions';

function formatAsCurrency(value) {
  return isNaN(value) ? null : Number(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

const mapStateToProps = state => ({
  user: state.Dashboard.user,
  errors: state.Global.errors
});

class PaymentComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false
    }

    this.onSubmit = this.onSubmit.bind(this);
    this.onUnmount = this.onUnmount.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
  }

  onUnmount = () => {
    if (this.props.errors && this.props.errors.filter(e => e.errType === 'bookingerror').length > 0) {
      this.props.dispatch(popError('bookingerror'));
    }
  }

  componentWillUnmount() {
    this.onUnmount();
  }

  onUpdate = () => {
    if (this.props.errors && this.props.errors.filter(e => e.errType === 'bookingerror').length > 0) {
      this.setState({ isSubmitting: false });
    }
  }

  componentDidUpdate() {
    this.onUpdate();
  }

  onSubmit() {
    setTimeout(() => this.setState({ isSubmitting: true }), 240);
    this.props.onSubmit();
  }

  renderBody(card, total, error) {
    if (!card) {
      return (<div>
        <div className="font-weight-bold">Sorry! No card found on account.</div>
        <span>Please go to your <Link to="/dashboard/account">Account Settings</Link> and set up a credit card to continue with the payment.</span>
      </div>);
    }
    return (<div>
      <div className="font-weight-bold">Continue payment with card on file:</div>
      <div key={card._id} className="col-12">
        <div>{card.brand ? `${card.brand.charAt(0).toUpperCase() + card.brand.slice(1)}` : ''} card ending in {card.lastFour}</div>
        <div>Expires {card.month}/{card.year}</div>
        <div>Amount: ${formatAsCurrency(total)}</div>
      </div>
      {error && (<div className="error-message">{error.message}</div>)}
    </div>)
  }

  renderButtonRow(card, error, onClose, isSubmitting) {
    let button = (<div />);
    if (error) { button = (<button className='btn btn-primary' disabled={true} >Error</button>) }
    else if (isSubmitting) { button = (<button className='btn btn-primary' disabled={true} >Processing...</button>) }
    else if (card) { button = (<button className='btn btn-primary' onClick={this.onSubmit} >Pay</button>) }
    return (
      <div className="w-100 row align-items-center m-0">
        <div className="col pl-0">
          <label onClick={onClose}>Back</label>
        </div>
        <div className="col text-right">
          {button}
        </div>
      </div>
    )
  }


  render() {
    let { isSubmitting } = this.state;
    let { user, total, errors, onClose } = this.props;
    let card = null;
    if (user.creditCards && user.creditCards.length > 0)
      card = user.creditCards[0];
    let error = errors ? errors.filter(e => e.errType === 'bookingerror')[0] : null;
    return (<ModalComponent
      id="CheckoutModal"
      title="Checkout"
      body={this.renderBody(card, total, error, isSubmitting)}
      footer={this.renderButtonRow(card, error, onClose, isSubmitting)}
      onClose={onClose} />
    );
  }
}

export default connect(mapStateToProps)(PaymentComponent);
